export const FEATURE_KEYS = {
  DUBBING: 'dubbing',
  RECAPTCHA_TRY_LISTEN_TTS_TYPE: 'recaptcha-try-listen-tts-type',
  RECAPTCHA_TTS_TYPE: 'recaptcha-tts-type',
  TRY_LISTEN_TTS: 'try-listen-tts',
  OLD_AUTO_SAVE_DRAFT: 'old-auto-save-draft',
  AUTO_SAVE_DRAFT_MOBILE: 'auto-save-draft-mobile',
  DOWNLOAD_AUDIO_LINK: 'download-audio-link',
  NEW_PLAY_AUDIO_LINK: 'new-play-audio-link',
  HIGHLIGHT_TO_PREVIEW: 'highlight-to-preview',
  CONFIG_AUTO_RENEW_PREPAID_PACKAGE: 'config-auto-renew-prepaid-package',
  SUBSCRIPTION: 'subscription',
  DUBBING_BY_UNIT_SECOND: 'dubbing-by-unit-second',
  SEPARATE_AIVOICE_PRODUCTS: 'separate-aivoice-products',
  MULTIPLE_INPUT_DUBBING: 'multiple-input-dubbing',
  DISCOUNT_FOR_FIRST_PAID_USER: 'discount-for-first-paid-user',
  VOICE_CLONING: 'voice-cloning',
  VOICE_CLONING_HOMEPAGE: 'voice-cloning-homepage',
  LIMIT_DOWNLOAD_FREE_PACKAGE: 'limit-download-free-package',
  NEW_DUBBING_UI: 'new-dubbing-ui',
  STREAMING_PREVIEW: 'streaming-preview',
  HOME_PAGE: 'home-page',
  DUBBING_SUBTITLE_TIMELINE: 'dubbing-subtitle-timeline',
  DUBBING_MULTIPLE_VOICES: 'dubbing-multiple-voices',
  DUBBING_PROJECTS: 'dubbing-projects',
  MULTIPLE_LANGUAGES_SRT: 'multiple-languages-srt',
  VIEW_VIDEO_WITH_TIMELINE: 'view-video-with-timeline',
  STT: 'stt',
  USE_PRESERVATION_EXPIRY_DATE: 'use-preservation-expiry-date',
  DATASENSES: 'datasenses',
  HEADER_BANNER_FLASH_SALE: 'header-banner-flash-sale',
  FAKE_END_TIME_VOUCHER: 'fake-time-voucher',
  NEW_LEGAL: 'new-legal',
  DEFAULT_BANK: 'default-bank',
  NEW_WARNING_BUY_PACKAGE: 'new-warning-buy-package',
  NEW_TTS_LAYOUT: 'new-tts-layout',
  NEW_LAYOUT_PAYMENT_METHOD: 'new-layout-payment-method',
  BLOCK_SPAM_EMAIL: 'block-spam-email',
  NEW_REQUESTS_LAYOUT: 'new-requests-layout',
  NEW_GLOBAL_ORDER: 'new-global-order',
  AUTO_PLAY_REQUEST: 'auto-play-request',
  INFINITE_SCROLL_REQUESTS: 'infinite-scroll-requests',
  PHONE_COUNTRY_INPUT: 'phone-country-input',
  VC_NEW_RECORDING: 'vc-new-recording',
  LOADING_LOAD_REQUEST: 'loading-load-request',
  NEW_PACKAGES_TAB: 'new-packages-tab',
  NEW_DICTIONARY_UI: 'new-dictionary-ui',
  NEW_PAGINATION: 'new-pagination',
  PREVIEW_ON_MOBILE_WEB: 'preview-on-mobile-web',
  CUSTOM_READING_METHOD: 'new-reading-method',
  ICON_NEW_DICTIONARY: 'icon-new-dictionary',
  AUDIO_EFFECT_MOBILE_WEB: 'audio-effect-mobile-web',
  NEW_POPUP_CHOOSE_VOICE: 'new-popup-choose-voice',
  BANNER_HOMEPAGE: 'banner-homepage',
  DICTIONARY_GUIDE: 'dictionary-guide',
  CUSTOM_SPEED_INPUT: 'custom-speed-input',
  SUGGEST_DICTIONARY: 'suggest-dictionary',
  NEW_HOMEPAGE: 'new-homepage',
  NEW_VOICES_LIST: 'new-voices-list',
  NEW_PRODUCTS_LIST: 'new-products-list',
  BREAK_TIME_MOBILE_WEB: 'break-time-mobile-web',
  READ_DICTIONARY: 'read-dictionary',
  NEW_HOMEPAGE_REQUEST: 'new-homepage-request',
  RESIZE_TTS_MOBILE: 'resize-tts-mobile',
  PUSH_EVENT_VIEW_PRICING: 'push-event-view-pricing',
  NEW_UX_SYNTHESIS: 'new-ux-synthesis',
  RENAME_MERGE_PRODUCT: 'rename-merge-product',
  NEW_HATE_SPEECH_DETECTOR: 'new-hate-speech-detector',
  NON_VBEE_CREDITS_FACTOR: 'non-vbee-credits-factor',
  VOICE_CREDITS_BY_LEVEL: 'voice-credits-by-level',
  NEW_SUBSCRIPTION_ITEM: 'new-subscription-item',
  NEW_PRICING_MODEL: 'new-pricing-model',
  PROMOTED_PACKAGE_MOE: 'promoted-package-moe',
  BLOCK_DUBBING_PAYMENT: 'block-dubbing-payment',
  SHOW_MULTIPLE_PACKAGES_INFO: 'show-multiple-packages-info',
  SYNC_AFFILIATE_MARKETER: 'sync-affiliate-marketer',
  SENTRY_AIVOICE_WEB_APP: 'sentry-aivoice-web-app',
  NEW_PRICE_VOUCHER: 'new-price-voucher',
  PERMATE_TRACKING: 'permate-tracking',
  SHOW_BLACK_WORDS_ON_MOBILE: 'show-black-words-on-mobile',
  VOICE_CLONING_AUTOMATED_TRAINING: 'voice-cloning-automated-training',
  NEW_DUBBING_REQUESTS_LIST: 'new-dubbing-requests-list',
  AMAZON_VOICE_SPEED_CONTROL: 'amazon-voice-speed-control',
  NON_VBEE_BREAK_TIME: 'non-vbee-break-time',
  AI_EDITTING: 'ai-editing',
  PERCENT_DISCOUNT_PAYMENT: 'percent-discount-payment',
  NEW_HEADER_UI: 'new-header-ui',
  INTRODUCE_NEW_MOBILE_APP: 'introduce-new-mobile-app',
  VNPAY_DISCOUNT_INFO: 'vnpay-discount-info',
  MULTILINGUAL_VOICE: 'multilingual-voice',
  NEW_QR_FLOW: 'new-qr-flow',
  NEW_PRICING_MODEL_V3: 'new-pricing-model-v3',
  USE_USAGE_OPTIONS_IN_PACKAGE: 'use-usage-options-in-package',
  UI_BUY_TOP_UP_CHARACTERS: 'ui-buy-top-up-characters',
  PACKAGE_INFO_V3: 'package-info-v3', // this for v3 pricing model
  PAYMENT_QR_V2: 'payment-qr-v2',
  NEW_MY_PACKAGE: 'new-my-package',
  MIGRATE_OLD_PKG_TO_V3: 'migrate-old-pkg-to-v3',
  SHOW_POPUP_MIGRATE_V3: 'show-popup-migrate-v3',
  REFUND_PRICE_CURRENT_PLAN: 'refund-price-current-plan',
  VOICE_SELECTION_NOTICE: 'voice-selection-notice',
  LIMIT_CREATE_VOICE_CLONING: 'limit-create-voice-cloning',
  LOCK_ONE_TIME_CREDITS_ADVANCED_VOICE: 'lock-one-time-credits-advanced-voice',
  USE_MIN_PAYMENT_METHOD_AMOUNT: 'use-min-payment-method-amount',
  SIGNUP_SURVEY: 'signup-survey',
  PROJECT: 'project',
  VALIDATE_VOICE_CLONING_ON_PLAN_CHANGE:
    'validate-voice-cloning-on-plan-change',
  NEW_CONTACT_SUPPORT: 'new-contact-support',
  UPDATE_VOICES_BY_USER_EOL_DATE: 'update-voices-by-user-eol-date',
  VOUCHER_FOR_AUTO_RENEW: 'voucher-for-auto-renew',
  VOICE_HAS_BEEN_RENAMED: 'voice-has-been-renamed',
};
